import { Modal } from '@/components/Modal/Modal';
import { Button } from '@/components/Button/Button';
import { t } from '@/lib/i18n';
import { useConnectorGrants, useCreateGrant, useRevokeGrant } from '../hooks';
import styles from './ConnectorGrantsModal.module.css';

interface Props {
  connectorId: string | null;
  connectorName: string;
  onClose: () => void;
}

export function ConnectorGrantsModal({ connectorId, connectorName, onClose }: Props) {
  const { data, isLoading } = useConnectorGrants(connectorId ?? '');
  const createGrant = useCreateGrant(connectorId ?? '');
  const revokeGrant = useRevokeGrant(connectorId ?? '');

  if (!connectorId) return null;

  function handleToggle(memberId: string, granted: boolean) {
    if (granted) {
      revokeGrant.mutate(memberId);
    } else {
      createGrant.mutate({ memberId, allowlist: null });
    }
  }

  return (
    <Modal
      open
      onOpenChange={(open) => !open && onClose()}
      title={`${t('Manage grants')} — ${connectorName}`}
      size="lg"
      actions={
        <Button variant="secondary" size="sm" onClick={onClose}>
          {t('Done')}
        </Button>
      }
    >
      {isLoading ? (
        <p className={styles.loading}>{t('Loading…')}</p>
      ) : (
        <ul className={styles.list}>
          {(data?.grants ?? []).map((g) => (
            <li key={g.memberId} className={styles.row}>
              <div className={styles['member-meta']}>
                <span className={styles['member-name']}>{g.memberName}</span>
                {g.isAi && <span className={styles['ai-badge']}>{t('AI')}</span>}
              </div>
              <label className={styles.toggle}>
                <input
                  type="checkbox"
                  checked={g.granted}
                  onChange={() => handleToggle(g.memberId, g.granted)}
                />
                <span>{g.granted ? t('Granted') : t('No access')}</span>
              </label>
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
}
